'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpanderList = function (_Component) {
    (0, _inherits3.default)(ExpanderList, _Component);

    /* istanbul ignore next */
    function ExpanderList() {
        var _ref;

        (0, _classCallCheck3.default)(this, ExpanderList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpanderList.__proto__ || Object.getPrototypeOf(ExpanderList)).call.apply(_ref, [this].concat(args)));

        var openArray = [];
        _this.props.items.forEach(function (item, index) {
            if (item.open) {
                openArray.push(index);
            }
        });
        _this.state = {
            open: openArray
        };
        return _this;
    }

    (0, _createClass3.default)(ExpanderList, [{
        key: 'isOpen',
        value: function isOpen(itemId) {
            return this.state.open.indexOf(itemId) !== -1;
        }
    }, {
        key: 'handleExpand',
        value: function handleExpand(itemId) {
            var newOpenItems = this.state.open;
            if (this.isOpen(itemId)) {
                newOpenItems.splice(this.state.open.indexOf(itemId), 1);
            } else {
                newOpenItems.push(itemId);
            }

            this.setState({
                open: newOpenItems
            });
        }
    }, {
        key: 'getHeaderElement',
        value: function getHeaderElement(item, itemId) {
            var _this2 = this;

            var iconClassNames = item.body && (0, _classnames2.default)('expander-icon', 'rioglyph', 'rioglyph-chevron-down');
            return _react2.default.createElement(
                'div',
                { className: 'expander-list-header',
                    onClick: function onClick() {
                        if (item.body) {
                            _this2.handleExpand(itemId);
                        }
                    } },
                _react2.default.createElement(
                    'span',
                    { className: 'expander-list-header-content' },
                    item.header
                ),
                _react2.default.createElement('span', { className: iconClassNames })
            );
        }
    }, {
        key: 'getBodyElement',
        value: function getBodyElement(item, isOpen, mountOnEnter, unmountOnExit) {
            if (!item.body) {
                return;
            }

            return _react2.default.createElement(
                _reactBootstrap.Collapse,
                { 'in': isOpen, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit },
                _react2.default.createElement(
                    'div',
                    { className: 'expander-list-body-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'expander-list-body' },
                        item.body
                    )
                )
            );
        }
    }, {
        key: 'getListItem',
        value: function getListItem(item, itemId) {
            var isOpen = this.isOpen(itemId);
            var itemClassNames = (0, _classnames2.default)('list-group-item', item.className && '' + item.className, item.body && 'expandable', isOpen && 'open');

            return _react2.default.createElement(
                'li',
                { className: itemClassNames, key: itemId },
                this.getHeaderElement(item, itemId),
                this.getBodyElement(item, isOpen, this.props.mountOnEnter, this.props.unmountOnExit)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var listClassNames = (0, _classnames2.default)('expander-list list-group', this.props.className);

            return _react2.default.createElement(
                'ul',
                { className: listClassNames },
                this.props.items.map(function (item, index) {
                    return _this3.getListItem(item, index);
                })
            );
        }
    }]);
    return ExpanderList;
}(_react.Component);

exports.default = ExpanderList;


ExpanderList.defaultProps = {
    items: [],
    mountOnEnter: true,
    unmountOnExit: true
};

ExpanderList.propTypes = {
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        className: _propTypes2.default.string,
        header: _propTypes2.default.node.isRequired,
        body: _propTypes2.default.node,
        open: _propTypes2.default.bool
    })).isRequired,
    mountOnEnter: _propTypes2.default.bool,
    unmountOnExit: _propTypes2.default.bool,
    className: _propTypes2.default.string
};